import findLinkEntities from './findLinkEntities';
import Link from './Link';

const createLinkDecorator = () => ({
    strategy: findLinkEntities,
    component: Link
});

export default createLinkDecorator;
